import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

interface MoxieEvent extends Event {
	readonly detail: {
		agentId?: number;
		sessionId: number;
	};
}

const moxieData = {
	ltf_WebsiteURL: window.location.href,
	ltf_webCLUBID: 0,
	ltf_webCLUBState: ''
};

const updateClubData = (clubData: ltFramework.IProspectProfile) => {
	if (clubData.club.id) {
		moxieData.ltf_webCLUBID = clubData.club.id;
		moxieData.ltf_webCLUBState = clubData.club.stateName;
	}
};

const updateMoxieChannelsData = () => {
	window.GoMoxie.conciergeV2.channelsData(moxieData);
};

function isMoxieEvent(event: Event): event is MoxieEvent {
	return 'detail' in event;
}

const trackEvent = (eventName: string, event: Event) => {
	if (!isMoxieEvent(event)) {
		return;
	}
	const data: {
		event: string;
		chatSessionId: number;
		agentId?: number;
	} = {
		event: eventName,
		chatSessionId: event.detail.sessionId
	};
	if (event.detail.agentId) {
		data.agentId = event.detail.agentId;
	}
	window.adobeDataLayer.push(data);
};

export function updateMoxie() {
	if (!window.adobeDataLayer) {
		window.adobeDataLayer = [] as any;
	}

	const conciergeReady = new Promise(function (resolve) {
		window.addEventListener('GoMoxie:conciergeReady', resolve);
	});

	conciergeReady.then(function () {
		const ProspectProfileStore = window.ef.prospectProfileStore;
		updateClubData(ProspectProfileStore.getInitialData());
		updateMoxieChannelsData();

		ProspectProfileStore.listen((club: ltFramework.IProspectProfile) => {
			updateClubData(club);
			updateMoxieChannelsData();
		});

		window.addEventListener(
			'GoMoxie:widget:chat:chatSessionStarted',
			(e: Event) => {
				trackEvent('Chat Session Started', e);
			},
			false
		);

		window.addEventListener(
			'GoMoxie:widget:chat:agentJoinedSession',
			(e: Event) => {
				trackEvent('Chat Agent Joined', e);
			},
			false
		);

		window.addEventListener(
			'GoMoxie:widget:chat:chatSessionEnded',
			(e: Event) => {
				updateMoxieChannelsData();
				trackEvent('Chat Session Ended', e);
			},
			false
		);
	});
}
